<script lang="ts" setup>
import { useRouter } from 'vue-router/composables'
import { useUserStore } from '@/stores'

const router = useRouter()
const userStore = useUserStore()

function goToRecharge() {
  router.push({ name: 'pay' })
}
</script>

<template>
  <div class="coin-entry flex items-center cursor-pointer shrink-0" @click="goToRecharge">
    <!-- 带加号的钻石图标，向左突出覆盖在胶囊之上 -->
    <img
      src="/images/vowpath/coins/coin-add.webp"
      class="coin-gem shrink-0"
      alt=""
    >
    <!-- 渐变胶囊 -->
    <div class="coin-pill flex items-center">
      <!-- 余额数字 -->
      <span class="coin-balance">{{ userStore.coinBalance }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.coin-gem {
  width: 32px;
  height: 28px;
  position: relative;
  z-index: 2;
  margin-right: -10px;
}

.coin-pill {
  background: linear-gradient(270deg, rgba(255, 119, 214, 1) 0%, rgba(172, 116, 255, 1) 100%);
  border-radius: 20px;
  height: 20px;
  padding: 0 12px 0 16px;
}

.coin-balance {
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  line-height: 16px;
}
</style>
